import React, { useState } from 'react';
import ModalForm from '../ModalBlock/ModalForm/ModalForm';
import MaterialsForm from '../Forms/SpecificForms/MaterialsForm';

const formData = {
  title: 'Получить материалы для подготовки',
  sentContent: {
    title: 'Отправили материалы для подготовки на вашу почту',
  },
};

function MaterialsModal({
  extraLeadData,
  ymSubmitEventType,
  ymSubmitExtraEventType,
  myTargetEvent,
}) {
  const [isFormSent, setIsFormSent] = useState(false);
  const [isError, setIsError] = useState(false);

  return (
    <ModalForm {...formData} isSent={isFormSent} isError={isError}>
      <MaterialsForm
        setIsSent={setIsFormSent}
        setIsError={setIsError}
        extraLeadData={extraLeadData}
        ymSubmitEventType={ymSubmitEventType}
        ymSubmitExtraEventType={ymSubmitExtraEventType}
        myTargetSubmitEventType={myTargetEvent}
      />
    </ModalForm>
  );
}

export default MaterialsModal;
